import { buildAccountantReportHtml, type AccountantReportView } from 'shared-models/browser';
import { MONEY_DECIMALS, roundMoney } from '../../../../utils/money';
import type { DateRange } from './accountant-report.types';

const pad = (n: number): string => String(n).padStart(2, '0');

// yyyy-mm-dd for a local date (no timezone shift).
export function toIsoDate(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function previousMonthRange(now: Date = new Date()): DateRange {
  const first = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const last = new Date(now.getFullYear(), now.getMonth(), 0);
  return { from: toIsoDate(first), to: toIsoDate(last) };
}

// dd/mm/yyyy from an ISO timestamp; falls back to the raw string when unparseable.
export function formatReportDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return iso;
  }
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// 1,234.50 — 2-decimal thousands-grouped money for the preview cells.
export function formatMoney(value: number): string {
  const digits = MONEY_DECIMALS === 0 ? 0 : 2;
  return (MONEY_DECIMALS === 0 ? roundMoney(value) : value).toLocaleString('he-IL', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function buildAccountantReportPrintHtml(view: AccountantReportView): string {
  return buildAccountantReportHtml(view, formatMoney, formatReportDate);
}
